<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <template v-slot:activator="{ on }">
        <v-btn color="mt-3 mb-3 body-2 primary" dark v-on="on">{{button}}</v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Cadastro de índices financeiros</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <h2
          class="title mx-4 mt-4 mb-1 text-xs-left"
          style="font-weight:400;"
        >Lista de índices financeiros</h2>
        <div
          class="caption text-xs-left px-4"
        >Crie índices para definição de áreas do seu condomínio</div>
        <v-flex xs4 px-5 ml-1 pt-3>
          <v-select
            class="iptSearchFinancialInd"
            v-model="condominium_id"
            :items="condominiumsList"
            append-icon="search"
            @click:append="getFinancialIndex(condominium_id)"
            item-text="name_fantasy"
            item-value="id"
            label="Selecione o condomínio"
          ></v-select>
        </v-flex>
        <FinacialIndexList :dataFinancialIndex="dataFinancialIndex" :openForm="openForm" />
        <RegisterFinancialIndex
          :fIdialogShow="fIdialogShow"
          :openForm="openForm"
          :closeForm="closeForm"
          :condominiumsList="condominiumsList"
          :getFinancialIndex="getFinancialIndex"
          :editDataFinancialIndex="editDataFinancialIndex"
        />
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import FinacialIndexList from "./FinacialIndexList";
import RegisterFinancialIndex from "./RegisterFinancialIndex";
export default {
  components: { FinacialIndexList, RegisterFinancialIndex },
  props: {
    button: String
  },
  data() {
    return {
      fIdialogShow: false,
      editDataFinancialIndex: null,
      condominiumsList: [],
      condominium_id: "",
      dataFinancialIndex: [],
      dialog: false
    };
  },
  mounted() {
    this.getComdominiums();
  },
  methods: {
    closeForm() {
      this.fIdialogShow = false;
      this.editDataFinancialIndex = null;
    },
    openForm(data) {
      // console.log(data);
      if (data) {
        this.editDataFinancialIndex = data;
      } else {
        this.editDataFinancialIndex = null;
      }
      this.fIdialogShow = true;
    },
    validSearch() {
      let fieldError = document.querySelector(".iptSearchFinancialInd label");
      fieldError.classList.add("primary--text");
      setTimeout(function() {
        fieldError.classList.remove("primary--text");
      }, 2000);
    },
    getFinancialIndex() {
      let dataSearch = {};
      dataSearch.params = { condominium_id: this.condominium_id };

      if (!this.condominium_id) {
        this.validSearch();
        return;
      }

      let query = { condominium_id: this.condominium_id };

      let obj = {
        url: "/api/financial",
        query: dataSearch,
        method: "get"
      };
      this.$store.dispatch("request/doRequest", obj).then(response => {
        this.dataFinancialIndex = response.data.map(item => {
          item.condominium_id = this.condominium_id;
          return item;
        });
      });
    },
    getComdominiums() {
      let obj = {
        url: "/api/condominium",
        query: "",
        method: "get"
      };
      this.$store.dispatch("request/doRequest", obj).then(response => {
        this.condominiumsList = response.data;
        this.condominiums = response.data;
      });
    }
  }
};
</script>